"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ValidationLevel_1 = require("../ValidationLevel");

var ValidationResult_1 = require("../ValidationResult");

var Validator_1 = require("../Validator");
/**
 * Validator that checks boundaries of a range.
 */


var RangeValidator =
/*#__PURE__*/
function (_Validator_1$Validato) {
  _inherits(RangeValidator, _Validator_1$Validato);

  function RangeValidator(min, max) {
    var _this;

    _classCallCheck(this, RangeValidator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RangeValidator).call(this, ValidationLevel_1.ValidationLevel.Fast));
    _this.min = min;
    _this.max = max;
    return _this;
  }

  _createClass(RangeValidator, [{
    key: "doValidate",
    value: function doValidate(value) {
      if (this.min !== null && value.minimum.comparedTo(this.min) < 0) {
        return new ValidationResult_1.ValidationError(RangeValidator.UNDER_MIN_VALUE_ERROR, this.min);
      }

      if (value.minimum.comparedTo(value.maximum) > 0) {
        return new ValidationResult_1.ValidationError(RangeValidator.INVALID_RANGE_ERROR);
      }

      if (this.max !== null && value.maximum.comparedTo(this.max) > 0) {
        return new ValidationResult_1.ValidationError(RangeValidator.OVER_MAX_VALUE_ERROR, this.max);
      }

      return new ValidationResult_1.ValidationSuccess(value);
    }
  }]);

  return RangeValidator;
}(Validator_1.Validator);

exports.RangeValidator = RangeValidator;
RangeValidator.UNDER_MIN_VALUE_ERROR = 'UNDER_MIN_VALUE';
RangeValidator.OVER_MAX_VALUE_ERROR = 'OVER_MAX_VALUE';
RangeValidator.INVALID_RANGE_ERROR = 'INVALID_RANGE';